module.exports = __webpack_public_path__ + "static/img/homeMenu_bg.16f4d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryCenter/homeMenu_bg.png
// module id = VDIH
// module chunks = 44